import { render, staticRenderFns } from "./RecordMap.vue?vue&type=template&id=21c7c22a&"
import script from "./RecordMap.vue?vue&type=script&lang=js&"
export * from "./RecordMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports